import React from 'react';
import { Link } from 'react-router-dom';
import './ProductCard.css';

const ProductCard = ({ product, onInquiry }) => {
  return (
    <div className="product-card">
      <div className="product-image">
        <img 
          src={`${process.env.PUBLIC_URL}${product.image}`} 
          alt={product.name}
          loading="lazy"
        />
        <div className="product-overlay">
          <div className="overlay-content">
            <div className="view-text">
              <span className="icon">🔍</span>
              Click to View Photos
            </div>
            <button 
              className="inquiry-button"
              onClick={(e) => {
                e.stopPropagation();
                onInquiry();
              }}
              aria-label={`Inquire about ${product.name}`}
            >
              <span className="whatsapp-icon">
                <svg viewBox="0 0 24 24" width="18" height="18">
                  <path fill="currentColor" d="M12.031 6.172c-3.181 0-5.767 2.586-5.768 5.766-.001 1.298.38 2.27 1.019 3.287l-.582 2.128 2.182-.573c.978.58 1.911.928 3.145.929 3.178 0 5.767-2.587 5.768-5.766.001-3.187-2.575-5.77-5.764-5.771zm3.392 8.244c-.144.405-.837.774-1.17.824-.299.045-.677.063-1.092-.069-.252-.08-.575-.187-.988-.365-1.739-.751-2.874-2.502-2.961-2.617-.087-.116-.708-.94-.708-1.793s.448-1.273.607-1.446c.159-.173.346-.217.462-.217l.332.006c.106.005.249-.04.39.298.144.347.491 1.2.534 1.287.043.087.072.188.014.304-.058.116-.087.188-.173.289l-.26.304c-.087.086-.177.18-.076.354.101.174.449.741.964 1.201.662.591 1.221.774 1.394.86s.274.072.376-.043c.101-.116.433-.506.549-.68.116-.173.231-.145.39-.087s1.011.477 1.184.564c.173.087.289.129.332.202.043.073.043.423-.101.827z"/>
                </svg>
              </span>
              Inquire on WhatsApp
            </button>
          </div>
        </div>
      </div>
      <div className="product-content">
        <div className="product-category">{product.category}</div>
        <h3 className="product-name">{product.name}</h3>
        <p className="product-description">{product.description}</p>
        {product.features && (
          <ul className="product-features">
            {product.features.map((feature, index) => (
              <li key={index}>{feature}</li>
            ))}
          </ul>
        )}
        {product.details && (
          <div className="product-details">
            {Object.entries(product.details).map(([key, value]) => (
              <div key={key} className="detail-item">
                <span className="detail-label">{key}:</span>
                <span className="detail-value">
                  {Array.isArray(value) ? value.join(', ') : value}
                </span>
              </div>
            ))}
          </div>
        )}
        <div className="product-actions">
          <Link 
            to={`/products?category=${product.categoryId}`}
            className="view-more"
          >
            View Collection
          </Link>
        </div>
      </div>
      {product.featured && (
        <div className="featured-badge">
          Featured
        </div>
      )}
    </div>
  );
};

export default ProductCard;
